import HeaderMono from "../ui/HeaderMono";
import { experience } from "../../content";

export default function Experience({ sectionTint }) {
    return (
        <section id="experience" className={`border-t border-white/5 ${sectionTint}`}>
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <HeaderMono>Experience</HeaderMono>
                <div className="grid md:grid-cols-2 gap-6">
                    {experience.map((job, i) => (
                        <article key={i} className="rounded-2xl border border-white/10 bg-white/5 hover:bg-white/[0.07] transition p-5">
                            <h3 className="font-semibold text-lg leading-tight">{job.role}</h3>
                            <p className="text-slate-300 text-sm">
                                {job.company}{job.location ? ` • ${job.location}` : ""} • {job.dates}
                            </p>
                            <ul className="mt-3 space-y-2 text-slate-300 text-sm list-disc pl-5">
                                {job.bullets.map((b, k) => <li key={k}>{b}</li>)}
                            </ul>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
